import React from "react";
import Form from "../../utils/Form";

const Register = () => {
  return (
    <div className="container w-full h-screen flex items-center justify-center">
      <Form id={2} />
    </div>
  );
};

export default Register;
